import * as Yup from 'yup';

export const RoleFormSchema = () =>
  Yup.object({
    name: Yup.string().required(),
    permissions: Yup.array(Yup.string().default('')).default([]),

    // additional information
    copier: Yup.string().default(''),
  });

export type RoleFormType = Yup.InferType<ReturnType<typeof RoleFormSchema>>;
